// 人才
import axios from '@/libs/api.request'
// Em注册
export const registerEm = data => {
  return axios.request({
    url: '/em/register',
    data,
    method: 'POST'
  })
}
// SmCm注册
export const registerSmCm = data => {
  return axios.request({
    url: '/smcm/register',
    data,
    method: 'POST'
  })
}
// 登陆
export const login = data => {
  return axios.request({
    url: '/login',
    data,
    method: 'PUT'
  })
}
// 退出
export const logout = data => {
  return axios.request({
    url: '/logout',
    data,
    method: 'PUT'
  })
}
// 忘记密码 -发送验证码
export const codeReset = data => {
  return axios.request({
    url: '/code/reset',
    data,
    method: 'PUT'
  })
}
// 忘记密码 -校验验证码
export const codeCheck = data => {
  return axios.request({
    url: '/code/check',
    data,
    method: 'PUT'
  })
}
// 忘记密码 - 重置密码
export const passReset = data => {
  return axios.request({
    url: '/pass/reset',
    data,
    method: 'PUT'
  })
}
// 完善信息
export const subBaseinfo = data => {
  return axios.request({
    url: '/baseinfo',
    data,
    method: 'POST'
  })
}
// 导师类型
export const getApplyIds = params => {
  return axios.request({
    url: '/applyIds',
    params,
    method: 'GET'
  })
}
// 获取导师个人信息
export const getBasicinfo = data => {
  return axios.request({
    url: '/baseinfo',
    data,
    method: 'GET'
  })
}
// 更新用户头像
export const setAvatar = data => {
  return axios.request({
    url: '/avaurl',
    data,
    method: 'POST'
  })
}
// 编辑导师-My preferred time for appointments
export const putFreetime = data => {
  return axios.request({
    url: '/freetime',
    data,
    method: 'PUT'
  })
}
// 编辑导师-Basic Info
export const putBasicinfo = data => {
  return axios.request({
    url: '/basicinfo',
    data,
    method: 'PUT'
  })
}
// 编辑导师-facts
export const putFacts = data => {
  return axios.request({
    url: '/facts',
    data,
    method: 'PUT'
  })
}
// 获取payment 信息
export const getPaymentinfo = data => {
  return axios.request({
    url: '/paymentinfo',
    data,
    method: 'GET'
  })
}
// 获取ugdPayment 信息
export const getUgdPaymentinfo = data => {
  return axios.request({
    url: '/ugd/paymentinfo',
    data,
    method: 'GET'
  })
}
// 导师选择那种类型
export const getMentorRole = data => {
  return axios.request({
    url: '/mentor/role',
    data,
    method: 'GET'
  })
}
// 导师类型切换
export const putMentorRole = data => {
  return axios.request({
    url: '/mentor/role',
    data,
    method: 'PUT'
  })
}
// 登陆后-获取导师类型
export const getUserRole = params => {
  return axios.request({
    url: '/userRole',
    params,
    method: 'GET'
  })
}
//  系统内部修改密码
export const subModifyPwd = data => {
  return axios.request({
    url: '/pwd',
    data,
    method: 'PUT'
  })
}
// 从后台获取是否开放修改capacity功能
export const capacityEditAccess = data => {
  return axios.request({
    url: '/capacity/modify/access',
    data,
    method: 'POST'
  })
}
// Capacity 编辑操作
export const capacityEdit = data => {
  return axios.request({
    url: '/capacity/modify',
    data,
    method: 'POST'
  })
}

// 个人信息 field
export const getField = data => {
  return axios.request({
    url: '/fields',
    data,
    method: 'POST'
  })
}
// 选择角色--获取合同信息
export const getConractInfo = data => {
  return axios.request({
    url: '/contract/info',
    data,
    method: 'POST'
  })
}
// 选择角色--重新签约
export const confirmContractResign = data => {
  return axios.request({
    url: '/contract/sign',
    data,
    method: 'POST'
  })
}
// 选择角色--取消后提醒
export const contractRemind = data => {
  return axios.request({
    url: '/contract/cancel/remind',
    data,
    method: 'POST'
  })
}
// 获取申请季注意事项确认状态
export const getApplyMattersConfirmStatus = data => {
  return axios.request({
    url: '/apply/matters/confirm/status',
    data,
    method: 'POST'
  })
}
// 修改申请季节注意事项确认状态为已确认
export const applyMattersConfirm = data => {
  return axios.request({
    url: '/apply/matters/confirm',
    data,
    method: 'POST'
  })
}
// 查询现在带的学生个数
export const jointCountInyear = data => {
  return axios.request({
    url: '/joint/count/by/inyear',
    data,
    method: 'POST'
  })
}
// 修改capacity
export const capacityTalents = data => {
  return axios.request({
    url: '/capacity/modify/by/talents',
    data,
    method: 'POST'
  })
}
// 是否弹窗Capacity
export const capacityTalentsModal = data => {
  return axios.request({
    url: '/capacity/confirm/remind',
    data,
    method: 'POST'
  })
}
// 回显Capacity
export const capacityBackForm = data => {
  return axios.request({
    url: '/capacity/count/by/remind',
    data,
    method: 'POST'
  })
}

// 修改支付信息
export const modifyPayment = data => {
  return axios.request({
    url: '/editPaymentinfo',
    data: data,
    method: 'post'
  })
}

// 导师专业
export const mentorMajor = data => {
  return axios.request({
    url: '/apply/mentor/tree',
    method: 'POST',
    data
  })
}
